import { DefoFunction } from 'ca-dom-binding/types';

/**
 * Defer importing a def view function until it's called
 *
 * @param {() => Promise<any>} moduleLoader A function to asynchrnously load the module
 * that has a defo view function as the default export.
 * Example: `() => import('path-to-module')`.
 */
export function importDeferredViewObserver(
  moduleLoader: () => Promise<any>
): DefoFunction {
  return (el: HTMLElement, props: any) => {
    return moduleLoader().then((m) => m.default(el, props));
  };
}
